<template>
  <page>
    <template slot='content'>
      <!-- <indicadores-preventiva-armazem></indicadores-preventiva-armazem> -->

      <!-- <Hr /> -->

      <os-armazem-externa-component></os-armazem-externa-component>
      <reloadPage></reloadPage>
    </template>
  </page>
</template>
  
<script>
import Page from '@/components/Page'
import OsArmazemExternaComponent from '../components/Armazem/OsArmazemExternaComponent.vue'
// import IndicadoresArmazem from '../components/IndicadoresArmazem.vue'
// import IndicadoresResumo from '@/components/IndicadoresResumo'
import reloadPage from '../common/reloadPage.vue'

export default {
  components: {
    Page,
    OsArmazemExternaComponent,
    // IndicadoresPreventivaArmazem,
    reloadPage
  },

  beforeDestroy() {
    clearTimeout(this.timer)
  },

  created() {

  },

  data() {
    return {
      isSidebarOpen: false,
      breadcrumbItems: [
        {
          text: 'Ordens para atendimento',
          active: true
        }
      ],
      timer: ''
    }
  },
  
  methods: {

  }
}
</script>
  